$(function () {
  // set window.sbf if not set by another file
  if (!window.sbf) {
    window.sbf = {};
  }

  // bind buttons with private overlay class to show the overlay
  // had to change 'on' syntax to work in IE 9
  $(document).on('click', 'a.private-event', function (click) {
    click.preventDefault();
    $('#private-event-check-overlay a[data-buttontype="join"]').attr('href', $(this).attr('href'));
    sbf.overlay.show('#private-event-check-overlay');

    // bind no button on private-event-check-overlay
    // cannot bind event on a hidden element so wait until it is visible ('one' is the same as using 'on' and then 'off')
    // had to change 'on' syntax to work in IE 9
    $('#private-event-overlay-cancel').one('click', function (click) {
      click.preventDefault();
      sbf.overlay.hide();
    });
  });
});
